import { runWhenIdle } from 'utils/idle';

export const isSSR = typeof window === 'undefined';

export function initialize(apiKey: string, onLoad: () => void) {
  if (!!apiKey && typeof window !== 'undefined' && typeof window.zE === 'undefined') {
    const appendScript = () => {
      // Waits for an idle slot rather than injecting immediately on 'load', since on slow
      // connections 'load' fires right as the JS bundle finishes — exactly when the page is
      // trying to paint its LCP element. Deferring here costs nothing: nobody expects the chat
      // widget to be ready before the page itself has rendered.
      runWhenIdle(() => {
        const s = document.createElement('script');
        s.id = 'ze-snippet';
        s.type = 'text/javascript';
        s.async = true;
        s.onload = onLoad;

        s.src = `https://static.zdassets.com/ekr/snippet.js?key=${apiKey}`;

        const x = document.getElementsByTagName('script')[0];
        x?.parentNode?.insertBefore(s, x);
      });
    };

    if (document.readyState === 'complete') {
      appendScript();
    } else if (window.attachEvent) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      window.attachEvent('onload', appendScript);
    } else {
      window.addEventListener('load', appendScript, false);
    }
  }
}
